import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    free: {
        tests: [],
        next: ''
    },
    premium: {
        tests: [],
        next: ''
    },
    boughtId: '',
    questions: {},
    testTitle: '',
    testResult: {},
    errors: {}
};

getters['fetchTestsFree'] = function(state) { return state.free.tests }
getters['fetchTestsFreeNext'] = function(state) { return state.free.next }
getters['fetchTestsPremium'] = function(state) { return state.premium.tests }
getters['fetchTestsPremiumNext'] = function(state) { return state.premium.next }
getters['fetchBoughtId'] = function(state) { return state.boughtId }
getters['fetchQuestions'] = function(state) { return state.questions }
getters['fetchTestTitle'] = function(state) { return state.testTitle }
getters['fetchTestResult'] = function(state) { return state.testResult }

const actions = {
    get(context, payload) {
        let url = payload == 'free' ? 'tests/free/' : 'tests/';
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_TESTS', [payload, response.data.results]);
                context.commit('SET_NEXT', [
                    payload,
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    getNext(context, payload) {
        return ApiService
            .get(context.state[payload].next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_TESTS', [payload, response.data.results]);
                context.commit('SET_NEXT', [
                    payload,
                    response.data.page,
                    response.data.num_pages,
                    response.data.url,
                    response.data.page_param
                ]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    buy(context, payload) {
        return ApiService
            .get('tests/' + payload + '/buy/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_QUESTIONS', response.data.questions);
                context.commit('SET_BOUGHT_ID', response.data.id);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    pass(context, payload) {
        return ApiService
            .get('tests/' + payload + '/pass/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_QUESTIONS', response.data.questions);
                context.commit('SET_TITLE', response.data.title);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    result(context, payload) {
        return ApiService
            .post('tests/' + payload.id + '/result/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_RESULT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    },
    share(context, payload) {
        return ApiService
            .post('tests/' + payload.id + '/share/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            })
    }
};

const mutations = {
    SET_TESTS(state, [type, tests]) {
        state[type].tests = tests;
        state.errors = {};
    },
    ADD_TESTS(state, [type, tests]) {        
        state[type].tests = state[type].tests.concat(tests);
        state.errors = {};
    },
    SET_NEXT(state, [type, page, num_pages, url, page_param]) {
        if (page < num_pages) {
            state[type].next =
            url +
            '?' +
            page_param +
            '=' +
            (page + 1);
        } else {
            state[type].next = '';
        }
        state.errors = {};
    },
    SET_QUESTIONS(state, questions) {
        state.questions = questions;
        state.errors = {};
    },
    SET_TITLE(state, testTitle) {
        state.testTitle = testTitle;
        state.errors = {};
    },
    SET_BOUGHT_ID(state, id) {
        state.boughtId = id;
        state.errors = {};
    },
    SET_RESULT(state, testResult) {
        state.testResult = testResult;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
